import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import formatCurrency from 'format-currency';

//import { setFormVisible } from 'bookingform';

import moment from 'moment';
import {
  BOOKING_STEP, sendCartShareEmail, setStep, updateCartShare,
  DEVICES,
  getBookingDetail,
  setEditBooking,
} from '../../../actions/Booking';
import { sortPaymentMethods } from '../../../utils/Payments';
import withNavigate from '../../../withNavigate'; // Importa el HOC

import CartRoom from '../rooms/CartRoom';
import CartDiscount from '../rooms/CartDiscount';
import HotelTax from '../hotels/HotelTax';
import RoomRateBoard from '../rooms/RoomRateBoard';
import PromoCodeDetail from '../rooms/PromoCodeDetail';
import ConfirmForm from './ConfirmForm';
import ExtraList from '../extras/ExtraList';
import ShareWithOthers from '../../share/ShareWithOthers';
import HotelShareCart from '../hotels/HotelShareCart';
import ReservationDetailsBlock from '../rooms/ReservationDetailsBlock';

import '../../../static/less/rooms/cart_rooms.less';
//import LoyaltyRedeem from '../../loyalty/LoyaltyRedeem';
import { showLoyaltyRedeem, showLoyaltyClaimPopup, convertCoinsToCurrency } from '../../../utils';
import { MULTIPLE_ROOMS, CALL_CENTER_ROLE } from '../../../constants';
import { store } from '../../../Store';
import { setCoinsApplied } from '../../../actions/Loyalty';
import BookingOverview from '../edit-bookings/BookingOverview';
import EditModeExit from '../edit-bookings/EditModeExit';
import BannerSandos4U from '../../loyalty/BannerSandos4U';

class CartRooms extends React.Component {
  handleBookNowClick = () => {
    this.setState({ isDisabled: false });

    // Cuando dan click en book now cerramos todos los extras
    this.setState({
      showCustomAndList: {
        [MULTIPLE_ROOMS.FIRST]: false,
        [MULTIPLE_ROOMS.SECOND]: false,
        [MULTIPLE_ROOMS.THIRD]: false,
        [MULTIPLE_ROOMS.FOURTH]: false,
      },
    });

    // Verifica si la referencia actual está definida y si childFunction está disponible
    if (this.child.current && typeof this.child.current.onBookNowClick === 'function') {
      // Llama a childFunction del componente hijo a través de la referencia
      this.child.current.onBookNowClick();
    } else {
      // childFunction is not available
    }
  }

  onCartShare = (url, emails) => {
    const { cartHotel, amount } = this.props.cart;
    const currentAmount = amount[cartHotel.currency.code];
    const roomAmounts = cartHotel.rooms.map((room) => {
      const rAmount = formatCurrency(room.amount[cartHotel.currency.code], cartHotel.currency);
      return {
        roomOrder: room.order,
        roomAmount: rAmount,
        currencyCode: cartHotel.currency.code,
      };
    });
    const totalAmount = formatCurrency(currentAmount, cartHotel.currency);

    const urlParts = url.substr(0, url.length - 1).split('/'); // remove last slash then split by slash
    const cartToken = urlParts[urlParts.length - 1]; // last part of the URL is the cart token

    return this.props.dispatch(sendCartShareEmail(cartToken, emails, roomAmounts, totalAmount));
  };

  constructor(props) {
    super(props);
    this.child = React.createRef();
    const numberRoomsHasExtras = Object.values(props.extras).reduce((acc, curr) => acc + (curr !== null), 0);
    const { cartHotel } = this.props.cart;

    this.state = {
      booking: null, // Objeto para obtener la booking cuando es isEditingBooking===true, para poder mandar ese objeto a BookingOverview
      loadEdigintBookingStatus: 'ready',
      numberRoomsHasExtras,
      roomNumberExtra: MULTIPLE_ROOMS.FIRST,
      showCustomAndList: {
        [MULTIPLE_ROOMS.FIRST]: true,
        [MULTIPLE_ROOMS.SECOND]: false,
        [MULTIPLE_ROOMS.THIRD]: false,
        [MULTIPLE_ROOMS.FOURTH]: false,
      },
      isDisabled: !props.isFreeModeSelected && numberRoomsHasExtras > 0
      && cartHotel.rooms[0].rate.name !== 'FLEXIBLE',
      //&& cartHotel.rooms[0].rate.name !== 'SEMIFLEXIBLE',
    };

    this.buildCartShareUrl = this.buildCartShareUrl.bind(this);
    this.onClickContinue = this.onClickContinue.bind(this);
    this.onToggleCustom = this.onToggleCustom.bind(this);
  }

  buildCartShareUrl() {
    return this.props.dispatch(updateCartShare(this.props.lang)).then((cartToken) => {
      if (!cartToken) {
        return null;
      }
      return `${process.env[`${this.props.chain}_BOOKING`]}/cart-share/${this.props.lang}/${cartToken}/`;
    });
  }

  componentDidMount() {
    // Forcing to scroll top
    window.scrollTo(0, 0);
    // Set the form to hidden to display the BookingFormSummary instead
    // Mandamos a redeem en caso necesario
    //this.props.dispatch(setFormVisible(false));
    // Pidieron que no se ocultara el booking form
    if (this.props.memberInfo) {
      this.props.dispatch(
        setCoinsApplied(this.props.coinsApplied));
    }

    /*if (this.props.isEditingBooking === true) {
      this.loadBooking(this.props.locator, this.props.email, this.props.lang);
    }*/
    // Ya no es necesario porque ya tenemos el objeto state.booking.editBooking
  }

  loadBooking(locator, email, lang) {
    this.setState({ loadEdigintBookingStatus: 'loading', booking: null });
    this.props.dispatch(getBookingDetail(lang, locator, 'email', email)).then((response) => {
      const { booking } = response;
      if (booking) {
        this.setState({ booking, loadEdigintBookingStatus: 'ready' });
      } else {
        this.setState({ loadEdigintBookingStatus: 'error' });
      }
    });
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    // We only should be in this page when the cart rooms have been added
    const { cartHotel } = this.props.cart;
    if (!cartHotel || cartHotel.rooms.length === 0 || !this.props.hotel) {
      this.props.navigate('/');
    } else {
      this.props.dispatch(setStep(BOOKING_STEP.CONFIRM));
    }
  }

  isIndividualRoomMode() {
    const { cartHotel } = this.props.cart;
    return cartHotel.rooms.length === 1 || this.props.isFreeModeSelected;
  }

  onToggleCustom(roomId) {
    this.setState({
      showCustomAndList: {
        ...this.state.showCustomAndList,
        [roomId]: !this.state.showCustomAndList[roomId],
      },
    });
  }

  onClickContinue(currentRoomId, shouldKeepExtrasSectionOpen = false) {
    const roomNumberExtra = parseInt(currentRoomId, 10) + 1;
    this.setState({ roomNumberExtra });
    this.setState({
      showCustomAndList: {
        [currentRoomId]: shouldKeepExtrasSectionOpen !== false,
        [roomNumberExtra]: true,
      },
    }, () => {
      this.setState({ isDisabled: false });
      if (shouldKeepExtrasSectionOpen === false) {
        if (this.state.numberRoomsHasExtras > parseInt(currentRoomId, 10)) {
          const { offsetTop } = document.getElementById(`room-extras-${roomNumberExtra}`);
          window.scrollTo(0, offsetTop);
        } else {
          const { offsetTop } = document.getElementsByClassName('ConfirmForm')[0];
          window.scrollTo(0, offsetTop);
        }
      }
    });
  }

  isUserLoggedIn() {
    if (this.props.memberInfo != null) {
      if (this.props.memberInfo.accountHolder != null) {
        return true;
      }
    }
    return false;
  }

  goToThanksPage = () => {
    // Acá si es agente, en correo debe mandarse el correo del agente
    let emailToQueryBooking = this.props.email;
    if (this.props.agentCode != null && this.props.agentCode !== ''
      && this.props.agentSell != null && this.props.agentSell === 'true') {
      emailToQueryBooking = this.props.memberInfo.email;
    }
    this.props.dispatch(getBookingDetail(
      this.props.lang,
      this.props.locator,
      'email',
      emailToQueryBooking,
    )).then((r) => {
      if (r && r.booking) {
        this.props.dispatch(setEditBooking(r.booking));
        this.props.navigate('/thanks/');
      }
      // Cargamos la reserva para obtener editBooking al igual que en /my-booking/
    });
  }

  renderLoadingEditingBooking() {
    return (
      <div className="row">
        <div className="col-md-12 col-sm-12" style={{
          justifyItems: 'center',
          marginTop: '20px',
        }}>
          <img src="/img/loading5.gif"/>
          <p style={{ fontWeight: 'bold', fontSize: '16px' }}>
            {this.context.t('Loading booking information...')}
          </p>
        </div>
      </div>
    );
  }

  render() {
    const { cartHotel } = this.props.cart;
    const { isDisabled, showCustomAndList } = this.state;
    if (!cartHotel || cartHotel.rooms.length === 0 || !this.props.hotel) {
      // return null;
      return (
        <Fragment>
          <div id="dropin-container" style={{ marginTop: '50px' }}></div>
          <button className='pay-latter-button' onClick={this.goToThanksPage}>
            {this.context.t('Cancel')}
          </button>
        </Fragment>
      ); // Ver si es necesario así
    }

    return (
            <div className="CartRooms">
              {/*Pidieron que se ocultara el HotelCardBlock*/}
              {/*this.props.openReservationDetails === false
              && <HotelCardBlock/>
              */}
              {/*this.props.openReservationDetails === false && this.props.chain !== PALAMIA_CHAIN
              && <div style={{ marginTop: '40px' }}>
                    <img src={bannerWeb4Ocean} alt="bannerWeb4Ocean" />
                  </div>
              */}
              {this.props.openReservationDetails === false
                && showLoyaltyRedeem() && this.props.isLoyaltyUserLoggedIn === false
                && showLoyaltyClaimPopup()
                && <div style={{ marginTop: '40px' }}>
                      <BannerSandos4U />
                    </div>
              }
              {this.props.openReservationDetails === false
              && <div className="flex justify-end mt-8 mb-2">
                <ShareWithOthers buildUrl={this.buildCartShareUrl} onShare={this.onCartShare}
                                 renderDescription={() => this.renderCartShare(cartHotel)}/>
              </div>}
              {/*this.renderGuaranteedPrice(cartHotel)}
              {<div className={`CartRoom__Rooms${this.isIndividualRoomMode() ? '' : '--combined'} row`}>
                {this.renderRooms(cartHotel)}
              </div>}
              {<div className="CartRooms-footer-container">
                <footer className="CartRooms-footer">
                  {this.renderCommonRateAndBoard()}
                  {this.renderPromoCode()}
                  {cartHotel.rooms.length > 1 && (
                          <div className="CartRooms__price sandbox border border-primary mt-3">
                            {this.renderPriceDetail()}
                          </div>
                  )}
                </footer>
              </div>*/}
              {this.props.openReservationDetails === false
                && this.renderPromoCode()
              }
              <div className='row'>

                  <div className={`col-xs-12 col-md-8 removeSpaceMd8 removeSpaceXs12 ${this.props.isMobile === true
                    && this.props.openReservationDetails === true ? 'hideConfirmForm' : ''}`}>
                    {/*Pidieron que se ocultara eso que sigue*/}
                    {/*<h2 className="best-rate-option-title">{this.context.t('Our best rate options for your reservation')}</h2>
                    <BoardDetailsBlock/>
                    {showLoyaltyRedeem() && this.isUserLoggedIn() === false && this.props.isCallCenterUser === false
                      && showLoyaltyClaimPopup()
                      && <div className='LoyaltyLoginContainer'>
                        <LoyaltyLoginBlock/>
                      </div>
                    }*/}
                    {/*showLoyaltyRedeem() && <LoyaltyRedeem loggedUser={this.props.loggedUser}
                                                          hotel={cartHotel} lang={this.props.lang}/>*/}

                    {/*!this.props.isFreeModeSelected && */
                      Object.entries(this.props.extras).map(([key, extras]) => extras
                      && cartHotel.rooms[0].rate.name !== 'FLEXIBLE'
                      //&& cartHotel.rooms[0].rate.name !== 'SEMIFLEXIBLE'
                      && (
                      <ExtraList
                        key={key}
                        showCustomAndList={showCustomAndList[key]}
                        extras={extras}
                        roomId={key}
                        hasToggle={true}
                        onClickContinue={this.onClickContinue}
                        onToggleCustom={this.onToggleCustom}
                      />
                      ))}
                    <div style={{ display: this.props.isEditingBooking === true ? 'none' : 'block' }}>
                      <ConfirmForm ref={this.child} paymentMethods={sortPaymentMethods(cartHotel.payment_methods)}
                      isDisabled={isDisabled}/>
                    </div>
                    {this.props.isEditingBooking === true && this.state.loadEdigintBookingStatus === 'loading'
                    && this.renderLoadingEditingBooking()}
                    {this.props.isEditingBooking === true && this.state.loadEdigintBookingStatus === 'ready'
                      && <EditModeExit/>
                    }
                    {this.props.isEditingBooking === true && this.state.loadEdigintBookingStatus === 'ready'
                    && this.props.editBooking != null && <BookingOverview/>}
                  </div>

                {(this.props.isMobile === false || (this.props.isMobile === true
                  && this.props.openReservationDetails === true))
                  && <div className='col-xs-12 col-md-4 removeSpaceMd4 removeSpaceXs12'>
                    <ReservationDetailsBlock hotel_name={this.props.hotel.name}
                      mostrarExtras={true}
                      checkIn={moment(this.props.lastRequestedInfo.checkin).format('ll')}
                      checkOut={moment(this.props.lastRequestedInfo.checkout).format('ll')}
                      handleBookNowClick={this.handleBookNowClick}
                      bookNowTextButton={this.state.isDisabled === false ? this.context.t('Book now') : this.context.t('Continue')}
                      />
                  </div>
                }
                {((this.props.isMobile === true
                  && this.props.openReservationDetails === false))
                  && this.renderSelectButton()
                }
              </div>

            </div>
    );
  }

  renderSelectButton() {
    const continueTextButton = this.props.isEditingBooking
      ? this.context.t('Confirm change') : this.context.t('Book now');
    const buttonClass = this.props.isCreatingBooking ? ' adding' : '';
    return (
      <button className={`continue ${buttonClass}`}
              onClick={() => this.handleBookNowClick()} disabled={this.props.isCreatingBooking}>
        {this.props.isCreatingBooking ? this.context.t('Wait a moment, please...') : continueTextButton}
      </button>
    );
  }

  renderCartShare(cartHotel) {
    const {
      lang, chain, hotel, lastRequestedInfo, distributions,
    } = this.props;
    const cartRoom = cartHotel.rooms[0];
    return (
            <HotelShareCart hotel={hotel} chain={chain} lastRequestedInfo={lastRequestedInfo}
                            cartRoom={cartRoom} lang={lang} distribution={distributions}/>
    );
  }

  renderCommonRateAndBoard() {
    if (this.isIndividualRoomMode()) {
      return null;
    }
    // This block is only rendered in TwoRoom mode for customers
    const firstRoom = this.props.cart.cartHotel.rooms[0]; // rate and board are common
    return (
            <RoomRateBoard hotel={this.props.hotel} room={firstRoom} lang={this.props.lang}
            new_member = {this.props.new_member}
            new_member_discount_percentage_activated = {this.props.new_member_discount_percentage_activated}
            loyaltyName = {this.props.loyaltyName}/>
    );
  }

  getNewMemberDiscountPercentage() {
    //Regresa loyalty.newMemberDiscountPercentage
    //Si es 0, regresa this.props.new_member_discount_percentage ya que eso es igual a chain.Data.new_member_discount_percentage
    if (this.props.new_member_discount_percentage != null) {
      if (this.props.new_member_discount_percentage > 0) {
        return this.props.new_member_discount_percentage;
      }

      return this.props.new_member_discount_percentage_chain;
    }
    return this.props.new_member_discount_percentage_chain;
  }

  renderDiscountDetail(currency) {
    const { amount, amountBefore } = this.props.cart;
    const amountCurrency = amount[currency.code];
    const amountBeforeCurrency = amountBefore[currency.code];
    let additionalDiscount = 0;
    if (this.props.new_member === true && this.props.new_member_discount_percentage_activated === true) {
      additionalDiscount = this.getNewMemberDiscountPercentage();
    }
    //TODOCANTIDADES
    //Acá es donde muestra el cuadro grande final a pagar, pidieron acá que sí se mostrará el descuento adicional
    //Esto se muestra cuando tienes varios cuartos seleccionados, al final aparecerá este cuadro donde sumariza
    return (
            <CartDiscount amount={amountCurrency} amountBefore={amountBeforeCurrency}
              additionalDiscount={additionalDiscount}/>
    );
  }

  renderGuaranteedPrice(cartHotel) {
    if (!cartHotel.show_best_price) {
      return null;
    }
    return (
            <div className="CartRooms--guaranteed">
              {this.context.t('Guaranteed online best price!')}
            </div>
    );
  }

  getFinalBookingAmount(bookingAmount, currency) {
    let coinsApplied = 0;
    if (this.props.coinsApplied != null) {
      coinsApplied = this.props.coinsApplied;
    }
    const state = store.getState();
    let finalAmount = bookingAmount;

    if (coinsApplied !== 0) {
      const discount = state.cart.is_custom_currency_rate
        ? convertCoinsToCurrency(coinsApplied, currency) : coinsApplied;
        // Tuvimos que agregar al método convertCoinsToCurrency el parámetro opcional currency, ya que
        // va al store y toma el currency de state.booking.filterCurrency, lo cual no coincidiría
        // con el currency que se toma de la ip del usuario
      finalAmount = bookingAmount - discount;
    }
    return finalAmount;
  }

  renderPriceDetail() {
    const { cart, lang } = this.props;
    const paymentCurrency = cart.cartHotel.currency;
    const amountBeforeCurrency = cart.amountBefore[paymentCurrency.code];
    const currentAmount = cart.amount[paymentCurrency.code];

    let amountToShow = currentAmount;
    amountToShow = this.getFinalBookingAmount(currentAmount, paymentCurrency);
    //Acá debemos de restar el porcentaje de descuento de nuevo miembro
    //Acá debe meterse la cantidad actualizada que coincida ya con lo que se va a pagar
    //Nos pidieron y lo confirmaron que en esta sección, que es cuando selecciona más de un cuarto, que la cantidad
    //que muestre sea ya la cantidad total a pagar
    //TODOCANTIDADES
    return (
            <div className="price-detail text-capitalize">
              <div className="price-detail__title">{this.context.t('Total price')}:</div>
              {this.renderDiscountDetail(paymentCurrency)}
              <div className="room-amounts">
                <div className="amount-price-block">
                  <div className="amount-price--crossed">
              <span className="amount-price__currency">
                {formatCurrency(amountBeforeCurrency, paymentCurrency)}
              </span>
                  </div>
                  <div className="amount-price">
              <span className="amount-price__currency">
              {formatCurrency(amountToShow, paymentCurrency)}
              </span>
                    <span className="amount-price__info">{this.context.t('* taxes included')}</span>
                  </div>
                </div>
                <HotelTax hotel={cart.cartHotel} lang={lang}/>
              </div>
            </div>
    );
  }

  renderPromoCode() {
    // The promocode is specified at the booking level, so we look for the data in any room
    const promoRoom = this.props.cart.cartHotel.rooms.find((room) => room.board.promocode_has_applied);
    if (!promoRoom) {
      return null;
    }
    const promoInfo = promoRoom.board;
    return (
            <PromoCodeDetail code={promoInfo.promocode_applied} description={promoInfo.promocode_description}/>
    );
  }

  renderRooms(cartHotel) {
    return cartHotel.rooms.map((cartRoom, roomIdx) => (
            <CartRoom
                    key={`CartRoom_${roomIdx}`}
                    position={roomIdx + 1}
                    hotel={this.props.hotel}
                    cartHotel={cartHotel}
                    cartRoom={cartRoom}
                    mode={this.isIndividualRoomMode() ? 'individual' : 'combined'}
                    userCurrency={this.props.filterCurrency}
            />
    ));
  }
}

CartRooms.propTypes = {
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

CartRooms.contextTypes = {
  t: PropTypes.func.isRequired,
};

// Conectar el componente con Redux
const mapStateToProps = (state) => ({
  chain: state.bookingFormState.chain,
  cart: state.cart,
  device: state.booking.device,
  filterCurrency: state.booking.filterCurrency,
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
  isCreatingBooking: state.session.isCreatingBooking,
  openReservationDetails: state.session.openReservationDetails,
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
  isCartUpdating: state.cart.isUpdating,
  lastRequestedInfo: state.booking.last_requested_info,
  isFreeModeSelected: state.bookingFormState.isFreeModeSelected,
  utmParams: state.bookingFormState.utmParams || {},
  loggedUser: state.loyalty.loggedUser,
  memberInfo: state.loyalty.memberInfo,
  loyalty: state.loyalty,
  extras: state.extras.extrasByRoomSelected,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  coinsApplied: state.loyalty.coinsApplied,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  currency: state.booking.filterCurrency,
  enteredCoins: state.loyalty.coinsEntered,
  maxCoinsToApply: state.loyalty.maxCoinsToApply,
  maxPercentUsage: state.loyalty.maxPercentUsage,
  currentStays: state.loyalty.currentStays,
  currentNights: state.loyalty.currentNights,
  distributions: state.bookingFormState.distributions.length > 0 ? state.bookingFormState.distributions
    : state.cart.cartHotel.rooms.map((room) => room.distribution),
  isEditingBooking: state.booking.isEditingBooking,
  locator: state.booking.book_locator,
  email: state.booking.book_email,
  editBooking: state.booking.editBooking,
  isInBookingDetailsPage: window.location.pathname.includes('/thanks/')
  || window.location.pathname.includes('/my-booking/')
  || window.location.pathname.includes('/booking-detail/'),
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
});

const ConnectedCartRooms = connect(mapStateToProps)(CartRooms);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedCartRooms);
